import { Grid, Box } from '@mui/material'
import { useState } from 'react'
import { departmentMockData } from '../../../mock-data/department-mock-data';
import GroupDots from "../../../assets/setting/mycompany/invoces/GroupDots.png";
import ActionHeader from '../../../UI/action-header/action-header';
import Vector from "../../../assets/common-imgs/Vector.png";
import GlobalCard from '../../../UI/card/GlobalCard';
import "./departments.scss"
import "../../../scss/common.scss"
import DepartmentDialogBox from './department-dialog-box';
import DeleteModal from './delete-modal';
import ClickAwayListener from '@mui/material/ClickAwayListener';

const Departments = () => {
  const [departmentData] = useState(departmentMockData);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [selectedId, setSelectedId] = useState('0');
  return (
    <div className='main-department'>
      <Box>
        <ActionHeader heading="Departments List" isbuttonRequired={true} buttonName="add Department" buttonImg={Vector} handleClick={setShowAddModal} /></Box>
      <GlobalCard>
        <Grid container className="global-card">
          {departmentData.map((data: any, index: any) => (
            <>
              <Grid key={index} item md={2.5} sm={6} xs={10} sx={{ p: 2, m: 2, backgroundColor: "#FFFFFF", display: 'flex', borderRadius: "10px", boxShadow: "0px 0px 10px rgba(182, 44, 127, 0.2)" }}>
                <Box>
                  <h4 className='heading-text-color margin-bottom'>{data.heading}</h4>
                  <p className='fs-14 line-hieght-2 text-color'>{data.departmentPara}</p>
                </Box>
                <Box sx={{ position: "relative", right: 0, }} className="br-5" ><img src={GroupDots} className='cursor-pointer' onClick={() => setSelectedId(data.id)} />
                  {/* <Box > */}
                  {selectedId === data.id &&
                    <ClickAwayListener onClickAway={() => setSelectedId("0")}>
                      <Box sx={{ position: "absolute", right: "1px", top: "30px", borderRadius: "5px", background: "#FFFFFF", boxShadow: "0px 0px 0px 4px rgba(247, 136, 18, 0.05);", py: 1, px: 3, display: 'flex', flexDirection: "column", justifyContent: "space-between" }}>
                        <p className='cursor-pointer margin-bottom' onClick={() => { setEditModalShow(true); setSelectedId('0') }}>Edit</p>
                        <p className='cursor-pointer' onClick={() => { setShowDeleteModal(true); setSelectedId('0') }} >Delete</p>
                      </Box>
                    </ClickAwayListener>
                  }
                </Box>
              </Grid>
            </>
          ))}
        </Grid>
        <Box sx={{ padding: "16px" }}>
          <span>Total:{departmentMockData.length}</span>
        </Box>
      </GlobalCard>
      {showAddModal && <DepartmentDialogBox showAddModal={showAddModal} setShowAddModal={setShowAddModal} />}
      <DeleteModal showDeleteModal={showDeleteModal} setShowDeleteModal={setShowDeleteModal} />
    </div>
  )
}
export default Departments